function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import PropTypes from "prop-types";

var SvgKitGnv = function SvgKitGnv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.24 11.5c.259 0 .469.224.469.5v8c0 .276-.21.5-.47.5-.258 0-.468-.224-.468-.5v-8c0-.276.21-.5.469-.5zm-20.552 0c.258 0 .468.224.468.5v8c0 .276-.21.5-.468.5-.26 0-.47-.224-.47-.5v-8c0-.276.21-.5.47-.5zM22.563 8H9.438c-4.143 0-7.5 3.582-7.5 8s3.357 8 7.5 8h13.124c4.143 0 7.5-3.582 7.5-8s-3.357-8-7.5-8zM9.438 7C4.777 7 1 11.03 1 16s3.778 9 8.438 9h13.124C27.223 25 31 20.97 31 16s-3.778-9-8.438-9H9.438z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.453 16.044a.1.1 0 01.1-.1h.66a.1.1 0 01.1.1v1.805c0 .03-.013.06-.037.078-.243.186-.525.33-.844.432-.336.107-.681.16-1.036.16-.5 0-.95-.106-1.351-.321a2.444 2.444 0 01-.945-.903A2.476 2.476 0 017.757 16c0-.48.114-.912.343-1.295.229-.383.544-.681.945-.896.406-.22.86-.33 1.365-.33.41 0 .784.069 1.12.204.305.123.566.298.783.525a.097.097 0 01-.004.136l-.435.425a.104.104 0 01-.143 0 1.833 1.833 0 00-1.28-.491c-.345 0-.652.072-.923.217a1.612 1.612 0 00-.63.609c-.15.261-.224.56-.224.896 0 .327.075.62.224.882.154.261.364.467.63.616.27.15.576.224.917.224.36 0 .68-.075.958-.224a.097.097 0 00.05-.086v-1.368zM17.993 13.55a.1.1 0 01.1.1v4.7a.1.1 0 01-.1.1h-.602a.1.1 0 01-.077-.037l-2.672-3.281v3.218a.1.1 0 01-.1.1h-.703a.1.1 0 01-.1-.1v-4.7a.1.1 0 01.1-.1h.601a.1.1 0 01.078.037l2.672 3.28V13.65a.1.1 0 01.1-.1h.703zM24.09 13.55a.1.1 0 01.092.14l-2.048 4.7a.1.1 0 01-.091.06h-.765a.1.1 0 01-.092-.06l-2.055-4.7a.1.1 0 01.092-.14h.768a.1.1 0 01.092.06l1.605 3.72 1.619-3.72a.1.1 0 01.092-.06h.691z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.792 16.79a.1.1 0 01-.1-.1v-.66a.1.1 0 01.1-.1h1.422a.1.1 0 01.1.1v.66a.1.1 0 01-.1.1h-1.422z",
    fill: props.color
  }));
};

SvgKitGnv.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgKitGnv.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgKitGnv;